import React, { Component } from 'react'
import { connect } from 'react-redux'
import ProductForm from './ProductForm'
import { updateProduct, saveProduct } from './products-reducer'

class ProductFormContainer extends Component {
  render () {
    const {
      inMemoryProduct,
      updateProduct,
      saveProduct,
      requestOngoing,
      successMsg
    } = this.props

    return (
      <div>
        <h4>Products Form</h4>
        <ProductForm
          productName={inMemoryProduct.name}
          productId={inMemoryProduct._id}
          productManufacturer={inMemoryProduct.manufacturer}
          onProductChange={updateProduct}
          onProductSave={() => saveProduct(inMemoryProduct)}
          requestOngoing={requestOngoing}
          successMsg={successMsg}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ products }) => ({
  inMemoryProduct: products.inMemoryProduct,
  error: products.error,
  requestOngoing: products.requestOngoing,
  successMsg: products.successMsg
})

const mapDispatchToProps = {
  updateProduct,
  saveProduct
}

export default connect(mapStateToProps, mapDispatchToProps)(
  ProductFormContainer
)



// WEBPACK FOOTER //
// ./src/products/ProductFormContainer.js